import { useState } from "react";
import { axiosFunction } from "../components/commonFunctions"; 
import { v2ReactURL } from "../utils/constant";
import { z } from "zod";


const dynamicSchema = z.array(
  z.record(z.number())
);
const useAnalyticsApi = () => {
  const [analyticsData, setAnalyticsData] = useState<Record<string, number> | undefined>(undefined);

  const fetchAnalyticsApi = async (contactType:string) => {
    const res = await axiosFunction(
      `${v2ReactURL}/contact/${contactType}/analytics`,
      "GET"
    );
    const validatedData = dynamicSchema.safeParse(res?.data);
    if (validatedData.success) {
      setAnalyticsData(validatedData.data[0]);
    } else {
      console.error("API response validation failed:", validatedData.error);
    }
  };

  return { fetchAnalyticsApi, analyticsData };
};

export default useAnalyticsApi;
